import { createI18n } from 'vue-i18n'
import dayjs from 'dayjs';

import 'dayjs/locale/uk';
import 'dayjs/locale/de';
import 'dayjs/locale/ru';
import 'dayjs/locale/en';
import 'dayjs/locale/es';


function requireAll(r) {
  return r.keys().reduce((acc, filename) => {
    const lang = (/\.\/(.+)\.js$/).exec(filename)[1];
    acc[lang] = r(filename).default;
    return acc;
  }, {});
}
const messages = requireAll(require.context('./langs/', true, /\.js$/));



const i18n = createI18n({
  // something vue-i18n options here ...
  locale: 'en',
  messages,
})

export default i18n;
